import React, { useEffect, useState } from 'react'
import '../css/todo.css'
import { object } from 'yup';
import Create from '../modals/Create';
import TaskCard from './TaskCard';
import { useTodoContext } from '../context/TodoContext';

const ToDo = () => {
  const {
    name, setModal, modal, toggle, taskList, setTaskList,
    loadTasks, saveTask, deleteTask, updateListArray } = useTodoContext();




  return (
    <>
      <div className="header text-center">
        <h3 >ToDo List</h3>
        <button className='btn btn-primary' onClick={() => setModal(true)}>Create Task</button>
      </div>
      <div className="container">
        <div className="row">
          {
            taskList?.map((task, index) => {
              return (
                <>
                  <div className="col sm-auto">
                    <TaskCard taskObj={task} index={index} />
                  </div>
                </>
              )
            })
          }
        </div>
      </div>
      <Create toggle={toggle} modal={modal} save={saveTask} />




      <Create toggle={toggle} modal={modal} save={saveTask} />
    </>




  )
}

export default ToDo